import * as helper from "../utils/helper"
import * as request from "../utils/request"
import { privacyEnums } from "../business/auth"

interface LoginState {
  openid: string
  openkey: string
  session_id: string
  session_type: string
  wx_appid?: string
  qq_appid?: string
}

export interface PrivacyAuthStatus {
  groupId: string
  authorized: boolean
}

function handlePrivacy({
  sandbox,
  offerId,
  loginState,
  action,
  subject_id,
  authorization,
  protocol = "1"
}: {
  sandbox: string
  offerId: string
  loginState: LoginState
  subject_id?: string
  action: "get_authorization" | "authorize"
  authorization?: privacyEnums
  protocol?: string
}): Promise<any> {
  return new Promise((resolve, reject) => {
    const env = helper.getCgiEnv(sandbox)
    const data: Record<string, string | number> = {
      action,
      ...loginState,
      protocol
    }
    if (authorization) {
      data.authorization = authorization
    }
    if (subject_id) {
      data.subject_id = subject_id
    }
    return request
      .ajax({
        url: `//${env}api.unipay.qq.com/v1/r/${offerId}/privacy_authorization`,
        data
      })
      .then((res: any) => {
        if (res.ret == 0) {
          resolve(res)
        } else {
          reject(res)
        }
      })
      .catch(reject)
  })
}

export async function getAuthPrivacy({
  sandbox,
  offerId,
  loginState
}: {
  sandbox: string
  offerId: string
  loginState: LoginState
}): Promise<Array<PrivacyAuthStatus>> {
  try {
    const results = await handlePrivacy({
      sandbox,
      offerId,
      loginState,
      action: "get_authorization"
    })
    return results.data.subject_list?.map(item => {
      return {
        groupId: item.id,
        authorized: item.status == 1
      }
    })
  } catch {
    return []
  }
}

export async function setAuthPrivacy({
  sandbox,
  offerId,
  loginState,
  subject_id,
  authorization
}: {
  sandbox: string
  offerId: string
  loginState: LoginState
  subject_id: string
  authorization: privacyEnums
}): Promise<void> {
  return await handlePrivacy({
    sandbox,
    offerId,
    loginState,
    subject_id,
    action: "authorize",
    authorization
  })
}
